import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { palette } from '../../styles/theme';

export function EmbedError ({ onRetry, message, minHeight = '30.769rem' }) {
    const { t } = useTranslation();

    return (
        <Box minHeight={minHeight} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <Typography sx={{ color: palette.error.main }} gutterBottom>
                {message || t('errors.embedLoad')}
            </Typography>
            <Button variant="contained" sx={{ backgroundColor: palette.primary.main }} onClick={onRetry}>
                {t('buttons.retry')}
            </Button>
        </Box>
    );
}
